import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./CorporatePageElementsCss/CorporateReport.css";
import { FaSearch, FaDownload, FaCalendarAlt } from "react-icons/fa";
import { getUserData, setUserData } from "../../utils/auth";
import {
  getBillIdWiseDownload,
  getBulkReports,
  getDownloadAllFile,
  getProfilebillData,
  getReportByBillId,
  getTestStatus,
  reportStatus,
  userLogin,
} from "../../api/api";
import toast from "react-hot-toast";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { PDFDocument } from "pdf-lib";
import CorporateReportStatusModal from "./CorporateReportStatusModal";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import CorporateViewModal from "./CorporateViewModal";
import "./CorporatePageElementsCss/CorporateRechargeModal.css";
import CorpoaretePayment from "./CorpoaretePayment";
import CorpoarateDownloadAllModal from "./CorpoarateDownloadAllModal";
import CustomLoader from "../../common/loader/CustomLoader";
import CorporateSelectedDownloadModal from "./CorporateSelectedDownloadModal";
import { FaCheckCircle } from "react-icons/fa";
import ItemLoader from "../../common/loader/ItemLoader";
import {
  diffInDays,
  getSelectedBillCount,
  getSelectedTestCount,
  parseDateChange,
} from "../../utils/helper";
const CorporateReport = () => {
  // const price = getUserData()?.CCBalance || "0.00";
  const [balanceLoading, setBalanceLoading] = useState(false);
  const [price, setPrice] = useState(getUserData()?.CCBalance || "0.00");

  const raw = localStorage.getItem("rb_corp_creds");
  const parsed = raw ? JSON.parse(raw) : {};
  const mobileNo = parsed?.mobile_no || "";
  const password = parsed?.password || "";
  const [billList, setBillList] = useState([]);
  const [reportList, setReportList] = useState([]);
  const [toggle, setToggle] = useState(false);
  const [smallLoader, setSmallLoader] = useState({});
  async function getReportData(fromDate, toDate) {
    const loadInitialData = async () => {
      setLoading(true);
      try {
        const today = toDate ? parseDateChange(toDate) : new Date();
        const defaultStart = fromDate
          ? parseDateChange(fromDate)
          : new Date(new Date().setDate(new Date().getDate() - 1));

        const minAllowed = new Date();
        minAllowed.setDate(today.getDate() - 7);
        setStartDate(defaultStart);
        setEndDate(today);

        const from = formatForPayload(defaultStart);
        const to = formatForPayload(today);
        setFromDate(from);
        setToDate(to);

        const centerId = getUserData()?.centerid;

        const payload = {
          Center_ID: centerId,
          From_date: from,
          LoginTypeVR: "CC",
          RBAuthKey: "RBDWAh!Q1s74e",
          To_date: to,
          mobile_no: mobileNo,
          password: password,
        };

        const response = await getProfilebillData(payload);
        console.log("Initial bill list response:", response);

        if (response.data?.status === "success") {
          let bills = response?.data?.data || [];
          setBillList(bills);
          setFilteredList(bills);
          return bills;
        }
      } catch (err) {
        console.log("Failed initial load:", err);
      } finally {
        setLoading(false);
      }
    };

    async function fetchStatuses(bills) {
      const smallLoaderMap = {};
      bills.forEach(async (bill) => {
        try {
          const status = await fetchBillStatus(bill.BillID);
          smallLoaderMap[bill.BillID] = true;
          setBillList((prevList) =>
            prevList.map((b) =>
              b.BillID === bill.BillID ? { ...b, ReportStatus: status } : b
            )
          );
          setFilteredList((prevList) =>
            prevList.map((b) =>
              b.BillID === bill.BillID ? { ...b, ReportStatus: status } : b
            )
          );
          setSmallLoader(smallLoaderMap);
        } catch (err) {
          console.log("Error fetching status for bill:", bill.BillID, err);
        }
      });
    }

    const bills = await loadInitialData();
    if (bills?.length > 0) {
      fetchStatuses(bills);
    }
  }
  useEffect(() => {
    getReportData();
  }, []);

  const fetchBillStatus = async (billId) => {
    // console.log("Fetching status for BillID:", billId);
    try {
      const payload = {
        BillID: billId,
        RBAuthKey: "RBDWAh!Q1s74e",
      };

      const response = await reportStatus(payload);

      if (response.data?.status === "success") {
        const reportList = response?.data?.data || [];

        // If ANY report is pending → status = Pending
        const hasPending = reportList.some(
          (r) => r.ReportStatus?.toLowerCase() === "pending"
        );
        if (hasPending) return "Pending";

        // If ALL are completed → Completed
        const allCompleted = reportList.every(
          (r) => r.ReportStatus?.toLowerCase() === "completed"
        );
        if (allCompleted) return "Completed";

        // Fallback
        return "Pending";
      }

      return "Pending";
    } catch (err) {
      return "Pending";
    }
  };

  const FetchListOfDateRange = async (from, to) => {
    if (!from || !to) {
      toast.error("Please select both From and To dates.");
      return;
    }
    // if (from > to) {
    //   toast.error("From date cannot be greater than To date.");
    //   return;
    // }
    // setLoading(true);
    try {
     await getReportData(fromDate, toDate);
    } catch (err) {
      console.log("Failed initial load:", err);
      toast.error('something goes wrong please try again')
    } 
  };

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [dateError, setDateError] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const datepickerRef = React.useRef(null);
  const [modalStatus, setModalStatus] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [reports, setReports] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [rechargeModal, setRechargeModal] = useState(false);
  const [downloadAllModal, setDownloadAllModal] = useState(false);
  const [downloadData, setDownloadData] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [filteredList, setFilteredList] = useState([]);
  const [selectedReport, setSelectedReport] = useState({});
  const [selectedDownloadModal, setSelectedDownloadModal] = useState(false);

  const handleBillList = async () => {
    // API call to fetch bill list can be implemented here
    const centerId = getUserData()?.centerid;
    try {
      const payload = {
        Center_ID: centerId,
        From_date: fromDate || "",
        LoginTypeVR: "CC",
        RBAuthKey: "RBDWAh!Q1s74e",
        To_date: toDate || "",
        mobile_no: mobileNo,
        password: password,
      };
      const response = await getProfilebillData(payload);
      if (response.data?.status === "success") {
        console.log("Bill list data:", response.data);
      }
    } catch (err) {}
  };

  const onChangeFrom = (val) => {
    setFromDate(val);
    setDateError("");
  };

  const onChangeTo = (val) => {
    setToDate(val);
    setDateError("");
  };

  // helper to format Date -> YYYY-MM-DD
  const formatForPayload = (d) => {
    if (!d) return "";
    // Return date in DD/MM/YYYY as required by API payload
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${dd}-${mm}-${yyyy}`;
  };

  const handleSearch = () => {
    const query = search.trim().toLowerCase();

    if (!query) {
      setFilteredList(billList);
      return;
    }

    const filtered = billList.filter((bill) => {
      return (
        bill.PatientName?.toLowerCase().includes(query) ||
        bill.BillID?.toString().toLowerCase().includes(query) ||
        bill.NetAmt?.toString().toLowerCase().includes(query)
      );
    });

    setFilteredList(filtered);
  };

  const fetchReportViewStatus = async (billId) => {
    try {
      setLoading(true);
      const payload = {
        BillID: billId,
        RBAuthKey: "RBDWAh!Q1s74e",
      };
      const response = await getTestStatus(payload);
      console.log("Report view status response:", response);
      if (response.data?.status === "success") {
        setReportList(response.data?.data || []);
        setModalStatus(true);
      }
    } catch (err) {
      console.log("Error fetching report view status:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchViewReportofBillId = async (billId) => {
    try {
      setLoading(true);
      const payload = {
        BillID: billId,
        RBAuthKey: "RBDWAh!Q1s74e",
      };

      const response = await reportStatus(payload);

      if (response.data?.status === "success") {
        setReports(response.data?.data || []);
        setViewModal(true);
      }
    } catch (err) {
      console.log("Error fetching report view status:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadReports = async (billId) => {
    setLoading(true);
    try {
      const payload = { BillID: billId, RBAuthKey: "RBDWAh!Q1s74e" };
      const response = await reportStatus(payload);

      if (response.data?.status !== "success") {
        toast.error("Could not fetch reports.");
        return;
      }

      const reportList = response.data?.data || [];

      if (reportList.length === 0) {
        toast.error("No reports available.");
        return;
      }

      // ✅ Pass ALL report objects to the ZIP function
      handleDownloadRow(billId, reportList);
    } catch (err) {
      console.log("Download error:", err);
      toast.error("Failed to download reports.");
    } finally {
      setLoading(false);
    }
  };

  const handleShowBill = (url) => {
    if (!url) return;
    window.open(url, "_blank");
  };
  const handleViewStatus = (billId) => {
    fetchReportViewStatus(billId);
  };
  const handleReportView = (billId) => {
    fetchViewReportofBillId(billId);
  };

  const sanitize = (text = "") =>
    text.replace(/[^\w\d]+/g, "_").replace(/^_|_$/g, "");

  const handleDownloadRow = async (billId, reports) => {
    if (!reports || reports.length === 0) {
      toast.error("No reports available to download.");
      return;
    }

    const mergedPdf = await PDFDocument.create();
    const total = reports.length;
    let completed = 0;

    // 🔹 Collect only unique report_image_url
    const urls = [...new Set(reports.map((rep) => rep.report_image_url).filter((url) => url))];

    if (urls.length === 0) {
      toast.error("No downloadable reports found.");
      return;
    }

    for (const url of urls) {
      try {
        const resp = await getBillIdWiseDownload({ printUrl: url });

        if (resp?.data?.status === "success" && resp.data.data) {
          let arrayBuffer;
          const fileData = resp.data.data;

          // ✅ Case 1: Base64
          if (typeof fileData === "string" && fileData.startsWith("data:")) {
            const base64 = fileData.split(",")[1];
            const byteChars = atob(base64);
            const byteNumbers = new Array(byteChars.length);

            for (let i = 0; i < byteChars.length; i++) {
              byteNumbers[i] = byteChars.charCodeAt(i);
            }

            arrayBuffer = new Uint8Array(byteNumbers).buffer;
          }
          // ✅ Case 2: Backend-served URL
          else {
            const res = await fetch(fileData);
            arrayBuffer = await res.arrayBuffer();
          }

          const tempPdf = await PDFDocument.load(arrayBuffer);
          const copiedPages = await mergedPdf.copyPages(
            tempPdf,
            tempPdf.getPageIndices()
          );
          copiedPages.forEach((page) => mergedPdf.addPage(page));
        }
      } catch (err) {
        console.error("Error merging report:", err);
        toast.error("Some reports could not be merged");
      }

      completed++;
    }

    // 🔹 Save merged PDF
    const mergedPdfBytes = await mergedPdf.save();
    const mergedBlob = new Blob([mergedPdfBytes], { type: "application/pdf" });

    const patientName = sanitize(reports[0]?.PatientName || "Patient");
    const billDate = sanitize(reports[0]?.BillDate || "");
    const today = new Date().toLocaleDateString("en-GB").replace(/\//g, "-");

    saveAs(mergedBlob, `${patientName}_${billDate}_${today}.pdf`);

    toast.success("Reports downloaded successfully!");
  };

  const handleDownloadAllReports = async () => {
    setDownloadAllModal(true);
    setToggle(!toggle);
  };

  const downloadSelectedReportsAsZip = async (reportItems) => {
    setIsDownloading(true);
    setProgress(0);

    try {
      const mergedPdf = await PDFDocument.create();
      const total = reportItems.length;
      let completed = 0;

      for (const rep of reportItems) {
        try {
          // 🔥 Call backend-safe API
          const resp = await getBillIdWiseDownload({
            printUrl: rep,
          });

          if (resp?.data?.status !== "success" || !resp.data.data) {
            throw new Error("Invalid PDF response");
          }

          let arrayBuffer;
          const fileData = resp.data.data;

          // ✅ Case 1: Base64
          if (typeof fileData === "string" && fileData.startsWith("data:")) {
            const base64 = fileData.split(",")[1];
            const byteChars = atob(base64);
            const byteNumbers = new Array(byteChars.length);

            for (let i = 0; i < byteChars.length; i++) {
              byteNumbers[i] = byteChars.charCodeAt(i);
            }

            arrayBuffer = new Uint8Array(byteNumbers).buffer;
          }
          // ✅ Case 2: Backend-served URL
          else {
            const res = await fetch(fileData);
            arrayBuffer = await res.arrayBuffer();
          }

          const tempPdf = await PDFDocument.load(arrayBuffer);
          const copiedPages = await mergedPdf.copyPages(
            tempPdf,
            tempPdf.getPageIndices()
          );
          copiedPages.forEach((page) => mergedPdf.addPage(page));
        } catch (err) {
          console.error("Download error:", err);
          toast.error("Some reports could not be downloaded");
        }

        completed++;
        setProgress(Math.round((completed / total) * 100));
      }

      // 🔄 Step: Save merged PDF (80% progress)
      setProgress(80);
      const mergedPdfBytes = await mergedPdf.save();
      const mergedBlob = new Blob([mergedPdfBytes], {
        type: "application/pdf",
      });

      // 🔄 Step: Download merged PDF (95% progress)
      setProgress(95);
      const today = new Date().toLocaleDateString("en-GB").replace(/\//g, "-");
      saveAs(mergedBlob, `RB_Selected_Reports_${today}.pdf`);

      // ✅ Mark as complete after delay to ensure OS receives file
      setTimeout(() => {
        setProgress(100);
        toast.success("Reports downloaded successfully!");
        setTimeout(() => setIsDownloading(false), 500);
      }, 500);
    } catch (err) {
      console.error(err);
      toast.error("Failed to download reports");
      setProgress(0);
      setIsDownloading(false);
    }
  };

  const downloadReportsAsZip = async (pdfUrls) => {
    setIsDownloading(true);
    setProgress(0);

    try {
      const mergedPdf = await PDFDocument.create();
      const total = pdfUrls.length;
      let completed = 0;

      for (const url of pdfUrls) {
        try {
          const arrayBuffer = await fetch(url).then((res) => res.arrayBuffer());
          const tempPdf = await PDFDocument.load(arrayBuffer);
          const copiedPages = await mergedPdf.copyPages(
            tempPdf,
            tempPdf.getPageIndices()
          );
          copiedPages.forEach((page) => mergedPdf.addPage(page));
        } catch (err) {
          console.error("Error merging:", err);
          toast.error("Error merging PDFs");
        }

        completed++;
        setProgress(Math.round((completed / total) * 100));
      }

      // 🔄 Step: Save merged PDF (80% progress)
      setProgress(80);
      const mergedPdfBytes = await mergedPdf.save();
      const mergedBlob = new Blob([mergedPdfBytes], { type: "application/pdf" });

      // 🔄 Step: Download merged PDF (95% progress)
      setProgress(95);
      const today = new Date().toLocaleDateString("en-GB").replace(/\//g, "-");
      saveAs(mergedBlob, `RB_Reports_${today}.pdf`);

      // ✅ Mark as complete after delay to ensure OS receives file
      setTimeout(() => {
        setProgress(100);
        toast.success("Reports downloaded successfully!");
        setIsDownloading(false);
      }, 500);
    } catch (err) {
      console.error(err);
      toast.error("Failed to download reports");
      setProgress(0);
      setIsDownloading(false);
    }
  };

  const handleOnProceed = (withHeader) => async () => {
    setLoading(true);
    try {
      const payload = {
        centerId: getUserData()?.centerid,
        From_date: fromDate || "",
        To_date: toDate || "",
        option: withHeader ? "option1" : "option2",
        RBAuthKey: "RBDWAh!Q1s74e",
      };
      const response = await getBulkReports(payload);
      const pdfList = response?.data?.bucketUrlData || [];
      await downloadReportsAsZip(pdfList);
      console.log("Bulk reports response:", response);
    } catch (err) {
      toast.error("Failed to download bulk reports. Please try again.");
      console.log("Error downloading bulk reports:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectedReports = async (billId, checked) => {
    if (checked) {
      try {
        setLoading(true);
        const payload = {
          RBAuthKey: "RBDWAh!Q1s74e",
          Bill_id: billId,
        };
        const response = await getReportByBillId(payload);

        if (response?.data?.status === "success") {
          const reports = response?.data?.data || [];
          setSelectedReport((prev) => ({
            ...prev,
            [billId]: reports,
          }));
        }
      } catch (err) {
        console.log("Error fetching report by bill id:", err);
      } finally {
        setLoading(false);
      }
    } else {
      // if unchecked, remove it
      setSelectedReport((prev) => {
        const updated = { ...prev };
        delete updated[billId];
        return updated;
      });
    }
  };

  const handleSelectedReportDownload = async () => {
    if (Object.keys(selectedReport).length === 0) {
      toast.error("Please select at least one bill to download reports.");
      return;
    }
    setSelectedDownloadModal(true);
  };

  const handleOnProceedSelected = (withHeader) => async () => {
    const allReports = Object.values(selectedReport).flat();
    if (allReports.length === 0) {
      toast.error("No reports available to download.");
      return;
    }

    setIsDownloading(true);
    try {
      const pdfUrlSet = new Set();

      for (const rep of allReports) {
        if (withHeader && rep.report_image_url) {
          pdfUrlSet.add(rep.report_image_url);
        }

        if (!withHeader && rep.report_image_url_print) {
          pdfUrlSet.add(rep.report_image_url_print);
        }
      }

      // Convert Set → Array
      const pdfUrls = Array.from(pdfUrlSet);

      if (pdfUrls.length === 0) {
        toast.error("No reports available to download.");
        return;
      }

      await downloadSelectedReportsAsZip(pdfUrls);
    } catch (err) {
      console.error("Error downloading selected reports:", err);
      toast.error("Failed to download selected reports.");
    } finally {
      setIsDownloading(false);
      setSelectedReport({});
      setSelectedDownloadModal(false);
    }
  };

  const handleRefereshBalance = async () => {
    try {
      setLoading(true);

      // 🔹 Read stored credentials
      const raw = localStorage.getItem("rb_corp_creds");
      if (!raw) {
        toast.error("Credentials not found. Please login again.");
        return;
      }

      const { mobile_no, password } = JSON.parse(raw);

      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        LoginType: "CC",
        mobile_no,
        password,
        deviceid: "",
      };

      const response = await userLogin(payload);

      if (response?.data?.status === "success") {
        // ✅ Update user data in storage
        setUserData(response.data);

        // ✅ Update price immediately in UI
        setPrice(response.data?.CCBalance || "0.00");

        // toast.success("Balance refreshed");
      } else {
        toast.error(response?.data?.message || "Failed to refresh balance");
      }
    } catch (err) {
      console.error("Balance refresh error:", err);
      toast.error("Could not refresh balance");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="corp-page">
      {loading && <CustomLoader />}
      {/* HEADER */}
      <div className="corp-header">
        <div className="balance-box">
          <span>CC Balance : ₹ {price}</span>
          <span className="refresh-icon" onClick={handleRefereshBalance}>
            ⟳
          </span>
        </div>
        <button className="recharge-btn" onClick={() => setShowModal(true)}>
          Recharge Now
        </button>
      </div>

      {/* <h1 className="corp-title">Corporate Reports List</h1> */}
      {/* <div className="heading-line"></div> */}

      {/* FILTER + ACTIONS */}
      <div className="corp-filter-card">
        <div className="filter-row">
          <div className="search-box">
            <input
              type="text"
              name="search"
              placeholder="Search"
              onChange={(e) => {
                setSearch(e.target.value);
                handleSearch(e.target.value); // triggers search while typing
              }}
            />
            <span className="search-icon">
              <i className="fa fa-search"></i>
            </span>
          </div>

          {/* <div className="date-range-box">
           
            <div
              className="date-input-row"
              style={{ alignItems: "center", position: "relative" }}
            >
              <DatePicker
                selectsRange
                startDate={startDate}
                endDate={endDate}
                minDate={(() => {
                  const d = new Date();
                  d.setDate(d.getDate() - 7);
                  return d;
                })()}
                maxDate={(() => {
                  const d = new Date();
                  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
                })()}
                onChange={(dates) => {
                  const [start, end] = dates;
                  setStartDate(start);
                  setEndDate(end);
                  if (start) onChangeFrom(formatForPayload(start));
                  if (end) onChangeTo(formatForPayload(end));
                }}
                isClearable={false}
                className="custom-input"
                ref={datepickerRef}
                dateFormat="dd/MM/yyyy"
                placeholderText={"Select date range"}
              />
              
              <span
                className="calendar-icon"
                onClick={() => datepickerRef.current?.setOpen(true)}
                aria-hidden
              >
                <FaCalendarAlt />
              </span>
              <button
                className="search-btn"
                onClick={() => FetchListOfDateRange(fromDate, toDate)}
                style={{ marginLeft: 8 }}
              >
                {" "}
                <FaSearch />{" "}
              </button>
            </div>
            {dateError && (
              <div style={{ color: "red", marginTop: 8 }}>{dateError}</div>
            )}
          </div> */}
          <div className="date-range-box">
            <div
              className="date-input-row"
              style={{ alignItems: "center", position: "relative" }}
            >
              <DatePicker
                selectsRange
                startDate={startDate}
                endDate={endDate}
                dateFormat="dd/MM/yyyy"
                placeholderText="Select date range"
                className="custom-input"
                ref={datepickerRef}
                isClearable={false}
                maxDate={new Date()} // ❌ disable future dates
                onChange={(dates) => {
                  const [start, end] = dates;

                  // First click
                  if (start && !end) {
                    setStartDate(start);
                    setEndDate(null);
                    setDateError("");
                    return;
                  }

                  // Second click
                  if (start && end) {
                    const startTime = start.getTime();
                    const endTime = end.getTime();

                    // ❌ Start > End (REAL date comparison)
                    if (startTime > endTime) {
                      setDateError(
                        "Start date cannot be greater than end date"
                      );
                      return;
                    }

                    // ❌ More than 7 days
                    const diffDays = Math.ceil(
                      (endTime - startTime) / (1000 * 60 * 60 * 24)
                    );

                    if (diffDays > 6) {
                      setDateError("Maximum 7 days date range allowed");
                      return;
                    }

                    // ✅ Valid range
                    setDateError("");
                    setStartDate(start);
                    setEndDate(end);

                    // ✅ Format ONLY here (safe)
                    setFromDate(formatForPayload(start));
                    setToDate(formatForPayload(end));
                  }
                }}
              />
            </div>
            {dateError && (
              <div style={{ color: "red", marginTop: 8 }}>{dateError}</div>
            )}
          </div>
          <button
            className="search-btn"
            disabled={!fromDate || !toDate}
            onClick={() => FetchListOfDateRange(fromDate, toDate)}
          >
            <FaSearch />
          </button>

          {Number(price) >= 0 && (
            <button
              className="download-selected-btn"
              disabled={
                Number(price) < 0 || Object.keys(selectedReport).length === 0
              }
              onClick={handleSelectedReportDownload}
              style={{
                opacity:
                  Number(price) < 0 || Object.keys(selectedReport).length === 0
                    ? 0.5
                    : 1,
                cursor:
                  Number(price) < 0 || Object.keys(selectedReport).length === 0
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              Download Selected Report(s)
              <FaDownload />
            </button>
          )}
          {Number(price) >= 0 && (
            <button
              className="download-bulk-btn"
              onClick={handleDownloadAllReports}
              disabled={Number(price) < 0}
            >
              Download Bulk Report(s)
              <FaDownload />
            </button>
          )}
        </div>

        <p className="note-text">
          Note: Maximum 7 days date range is allowed. 'First Date' should not be
          greater than 'Second Date'.
        </p>

        {/* Status Indicators */}
        {Number(price) >= 0 && (
          <div className="status-row">
            <div className="status-item">
              <span className="status-dot green"></span> Report Completed
            </div>
            <div className="status-item">
              <span className="status-dot yellow"></span> Report Pending
            </div>
          </div>
        )}
      </div>

      {/* TABLE */}
      <div className="corp-table-container">
        <table className="corp-table">
          <thead>
            <tr>
              {Number(price) >= 0 && <th></th>}
              <th>Acc No</th>
              <th>Date</th>
              <th>Patient Name</th>
              <th>Bill Amount</th>
              <th>View Bill</th>
              <th>Status</th>
              {Number(price) >= 0 && <th>Report Status</th>}
              {Number(price) >= 0 && <th>View</th>}
              {Number(price) >= 0 && <th>Reports</th>}
            </tr>
          </thead>
          {filteredList.map((bill, index) => (
            <tbody>
              <tr
                className={
                  bill?.ReportStatus === "Completed"
                    ? "completed-row"
                    : "pending-row"
                }
                key={index}
              >
                {Number(price) >= 0 && (
                  <td
                    onClick={() => {
                      handleSelectedReports(bill?.BillID);
                    }}
                  >
                    <input
                      type="checkbox"
                      onChange={(e) =>
                        handleSelectedReports(bill?.BillID, e.target.checked)
                      }
                      checked={!!selectedReport[bill?.BillID]}
                    />
                  </td>
                )}
                <td>{bill?.BillID}</td>
                <td>{bill?.BillDate}</td>
                <td>{bill?.PatientName}</td>
                <td>{bill?.NetAmt}</td>
                <td
                  style={{ cursor: "pointer" }}
                  onClick={() => handleShowBill(bill?.Bill_pdf_url)}
                >
                  🔗
                </td>
                <td
                  style={{ cursor: "pointer" }}
                  onClick={() => handleViewStatus(bill?.BillID)}
                >
                  ⬇
                </td>

                {Number(price) >= 0 && (
                  <td>
                    {/* {bill?.ReportStatus === "Completed" ? (
                      <span className="status-completed">
                        <FaCheckCircle
                          style={{ color: "green", marginRight: 6 }}
                        />
                        Completed
                      </span>
                    ) : (
                      <span className="status-pending">
                        {smallLoader[bill.BillID] ? (
                          `⏳ ${bill?.ReportStatus}`
                        ) : (
                          <ItemLoader />
                        )}
                      </span>
                    )} */}
                    {bill?.ReportStatus === "Completed" ? (
                      <span className="status-completed">
                        <FaCheckCircle
                          style={{ color: "green", marginRight: 6 }}
                        />
                        Fully Completed
                      </span>
                    ) : (
                      <span className="status-pending">
                        {smallLoader[bill.BillID] ? (
                          "⏳ Few Pending"
                        ) : (
                          <ItemLoader />
                        )}
                      </span>
                    )}
                  </td>
                )}

                {Number(price) >= 0 && (
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => handleReportView(bill?.BillID)}
                  >
                    <FaEye />
                  </td>
                )}
                {Number(price) >= 0 && (
                  <td>
                    <button
                      className="download-row-btn"
                      onClick={() => handleDownloadReports(bill?.BillID)}
                      style={{
                        opacity: 1,
                        cursor: "pointer",
                      }}
                    >
                      Download Reports <FaDownload />
                    </button>
                  </td>
                )}
              </tr>
            </tbody>
          ))}
        </table>
        {modalStatus && (
          <CorporateReportStatusModal
            open={modalStatus}
            onClose={() => setModalStatus(false)}
            //   bill={selectedBill}
            reportList={reportList}
          />
        )}
        {viewModal && (
          <CorporateViewModal
            open={viewModal}
            onClose={() => setViewModal(false)}
            reports={reports}
          />
        )}
        {showModal && (
          <div className="recharge-overlay">
            <div className="recharge-modal">
              <div className="recharge-header">
                <h3 className="recharge-title">Account Recharge</h3>
              </div>

              <button
                className="recharge-close"
                onClick={() => setShowModal(false)}
                aria-label="Close"
              >
                ✕
              </button>

              <div className="recharge-body">
                <h4 className="recharge-question">
                  Do you want to Recharge your account now ?
                </h4>

                <div className="recharge-options">
                  <label className="recharge-option">
                    <input
                      type="radio"
                      name="recharge"
                      onChange={() => {
                        setShowModal(false);
                        setRechargeModal(true);
                      }}
                    />{" "}
                    <span>Yes</span>
                  </label>
                  <label className="recharge-option">
                    <input
                      type="radio"
                      name="recharge"
                      onChange={() => setShowModal(false)}
                    />{" "}
                    <span>No</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        )}

        {rechargeModal && (
          <CorpoaretePayment
            open={rechargeModal}
            onClose={() => setRechargeModal(false)}
            balance={price}
            // onPay={handleRecharge}
          />
        )}
        {downloadAllModal && (
          <CorpoarateDownloadAllModal
            totalReports={billList.length}
            fromDate={fromDate}
            toDate={toDate}
            onClose={() => setDownloadAllModal(false)}
            onProceed={handleOnProceed}
            isDownloading={isDownloading}
            progress={progress}
          />
        )}
        {selectedDownloadModal && (
          <CorporateSelectedDownloadModal
            // totalReports={Object.values(selectedReport).flat().length}
            totalReports={getSelectedBillCount(selectedReport)}
            onClose={() => setSelectedDownloadModal(false)}
            onProceed={handleOnProceedSelected} // pass handler
            isDownloading={isDownloading}
            progress={progress}
          />
        )}
      </div>
    </div>
  );
};

export default CorporateReport;
